"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.isLinkProps = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Identity_1 = require("../../../identity/Identity");
var NavItem_1 = require("../../../nav/NavItem");
var Modal_1 = require("../../modal/Modal");
function isLinkProps(brand) {
    return brand.to !== undefined;
}
exports.isLinkProps = isLinkProps;
exports.Header = function (_a) {
    var brand = _a.brand, _b = _a.navItems, navItems = _b === void 0 ? [] : _b, navbarProps = tslib_1.__rest(_a, ["brand", "navItems"]);
    var t = react_i18next_1.useTranslation().t;
    var _c = Identity_1.useIdentityContext(), user = _c.user, logout = _c.logout, component = _c.component, identityProvider = _c.identityProvider;
    var _d = Modal_1.useModal({
        Component: Modal_1.Modal,
        title: t('Sign In / Sign Up'),
        body: component,
    }), modal = _d.modal, openModal = _d.openModal, closeModal = _d.closeModal;
    react_1.useEffect(function () {
        if (user) {
            closeModal();
        }
    }, [user]);
    var userMenuItems = [];
    var identityModal = undefined;
    if (identityProvider) {
        if (user) {
            userMenuItems.push(react_1.default.createElement("div", { key: "userNav", id: "userNav", title: user.displayName() },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/account" }, t('My account')),
                react_1.default.createElement(react_router_dom_1.Link, { to: "#", onClick: logout }, t('Log out'))));
        }
        else if (user === null) {
            var handleOnClick = function () { return openModal(); };
            userMenuItems.push(react_1.default.createElement(react_router_dom_1.Link, { to: "#", key: "signup_signin", onClick: handleOnClick }, t('Sign In / Sign Up')));
            identityModal = modal;
        }
    }
    var brandContent = react_1.default.createElement(react_1.default.Fragment, null);
    if (brand) {
        brandContent = isLinkProps(brand) ? react_1.default.createElement(react_router_dom_1.Link, tslib_1.__assign({}, brand)) : react_1.default.createElement(react_router_dom_1.Link, { to: "/" }, brand);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        identityModal,
        react_1.default.createElement("div", tslib_1.__assign({}, navbarProps),
            brandContent,
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null, navItems === null || navItems === void 0 ? void 0 : navItems.map(NavItem_1.navItemToComponent)),
                userMenuItems.length > 0 && react_1.default.createElement("div", null, userMenuItems)))));
};
//# sourceMappingURL=Header.js.map